module.exports = __webpack_public_path__ + "img/فانتزی.c81d5ec3.jpg";